import React from 'react';
import styled from 'styled-components';
import { Trans } from '@lingui/react';
import { Box, Flex } from '@components/layout/Grid';
import ThumbnailWithRatio, {
  BackgroundImage,
} from '@components/ThumbnailWithRatio';
import { NextDayTitle } from '@components/texts';
import { ProgramCategory, ProgramLiveEvent } from '@gql/generated';
import { CameraIcon } from '@assets/index';
import { useRouter } from 'next/router';
import VideoBox from './videoBox';

const Wrapper = styled.div`
  display: flex;
`;

const ThumbWrapper = styled(Box)<{
  appearance?: ProgramCategory;
  progress: number;
}>`
  position: relative;
  ${({ isHighlighted, appearance, theme }) => {
    return '';
    // if (isHighlighted) {
    //   if (appearance === ProgramCategory['Courses']) {
    //     return `border: 2px solid ${theme.colors.primary.green};`;
    //   } else {
    //     return `border: 2px solid ${theme.colors.secondary['gray-5']};`;
    //   }
    // }
  }}
  border-radius: ${({ isHighlighted }) => (isHighlighted ? '6px' : '4px')};
  overflow: hidden;

  :after {
    content: '';
    position: absolute;
    bottom: 0;
    left: 0;
    height: 3px;
    width: ${({ progress }) => progress}%;
    background-color: #129edc;
  }
`;

const Thumbnail = styled(ThumbnailWithRatio)<{
  appearance?: ProgramCategory;
}>`
  ${BackgroundImage} {
    ${({ isLocked, appearance, theme }) =>
      isLocked
        ? `
          :before {
            background-color: ${
              appearance === ProgramCategory['Challenges']
                ? theme.colors.primary.green
                : theme.colors.primary.stone
            };
          }
        `
        : ''}
  }
`;

const VideoTag = styled.span<{ color?: string }>`
  display: inline-flex;
  align-items: center;
  color: ${({ color }) => color ?? '#242424'};
  font-size: 12px;
  margin-right: 5px;

  & + & {
    margin-left: 5px;
  }

  svg {
    width: 12px;
    height: 12px;
    margin-right: 6px;
  }
`;

type Props = {
  lang: string;
  isHighlighted?: boolean;
  element: ProgramLiveEvent;
  weekSlug: string;
  programCategory: ProgramCategory;
};

export const LiveEventElementBox = (props: Props) => {
  const router = useRouter();
  const { lang, programId } = router.query;

  const { element, programCategory, weekSlug } = props;

  let baseUrl = `/${lang}/${programCategory}/${programId}/${weekSlug}/${element.slug}`;

  // event recordings not available so we show event card
  return (
    <Wrapper
      // DO NOT REMOVE THE CLASS videoBox, ITS USED TO DRAW THE PROGRESS INDICATOR
      className="videoBox"
      onClick={() =>
        router.push(baseUrl, null, { shallow: true, scroll: false })
      }
      style={{ cursor: 'pointer' }}
      // DO NOT REMOVE THE DATA ATTRIBUTES, THEY ARE USED TO DRAW THE PROGRESS INDICATOR
      data-video-finished={props?.['meta-data']?.finished === true}
      data-video-bonus={props?.['meta-data']?.bonus}
      data-video-last={props?.['meta-data']?.last}
      data-testid="VideoBox"
    >
      <ThumbWrapper
        flex="0 0 108px"
        mr="10px"
        isHighlighted={props.isHighlighted}
        appearance={props.programCategory}
      >
        <Thumbnail
          path={element?.liveEvent.thumbnail}
          appearance={props.programCategory}
          isLocked={element.locked}
        />
      </ThumbWrapper>
      <Flex flexDirection="column" justifyContent="center">
        <NextDayTitle
          isCurrent={props.isHighlighted}
          title={element?.title || element?.liveEvent?.title}
          data-testid="VideoBox--Title"
        >
          {element?.title || element?.liveEvent?.title}
        </NextDayTitle>
        <Flex alignItems="center">
          <VideoTag>
            <CameraIcon />
            <Trans id="weeklyProgram.live_event.label" />
          </VideoTag>
        </Flex>
      </Flex>
    </Wrapper>
  );
};
